// libraries
import React from 'react';
import styled from 'styled-components';
import { Link as ReactRouterLink } from 'react-router-dom';

// custom components
import Checkbox from 'components/Form/Checkbox';

// styled components
import { Flex, Label } from 'shared/styledComponents';
import { Text } from 'shared/typography';

const CheckboxWrapper = styled(Flex)`
  align-items: center;
  margin-top: 10px;
`;

const CheckboxLabel = styled(Label)`
  font-size: 10px;
  line-height: 1.4;
  color: ${({ theme: { colors } }): string => colors.white};
  margin-left: 20px;
`;

const StyledLink = styled(Text)`
  font-size: 10px;
  line-height: 1;
  color: ${({ theme: { colors } }): string => colors.white};
  text-decoration: underline;
`;

const TermsAcceptedCheckbox = (): JSX.Element => (
  <CheckboxWrapper>
    <Checkbox name="termsAccepted" />
    <CheckboxLabel>
      I have read the terms and conditions for&nbsp;
      <StyledLink as={ReactRouterLink} to="/terms-of-use" size="small" target="_blank">
        Terms of Use
      </StyledLink>
      ,&nbsp;
      <StyledLink as={ReactRouterLink} to="/privacy-policy" size="small" target="_blank">
        Privacy Policy
      </StyledLink>
    </CheckboxLabel>
  </CheckboxWrapper>
);

export default TermsAcceptedCheckbox;
